import styled, { css } from 'styled-components'
import DefaultColumn from '~components/dumbs/Column'
import DefaultRow from '~components/dumbs/Row'
import DefaultTitle from '~components/dumbs/Title'
import { CenteredWrapperProps } from './interfaces'

export const Row = styled(DefaultRow)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
  }
`

export const CenteredWrapper = styled(DefaultColumn)<CenteredWrapperProps>`
  flex: 1;
  align-items: center;

  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing.km6};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    align-items: flex-start;

    ${({ $isValid }) =>
      $isValid &&
      css`
        margin-bottom: 84px;
      `}
  }
`

export const Title = styled(DefaultTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`

export const ColumnTitle = styled.h3`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  letter-spacing: -0.03em;
  color: ${({ theme }) => theme.neutral.text.strong};
  margin-bottom: ${({ theme }) => theme.spacing.km6};
  margin-top: ${({ theme }) => theme.spacing.km6};
`

export const Content = styled.div`
  width: 209px;
`
